import QueriesCard from "./QueriesCard";
import ViewMoreList from "../ViewMoreList";
import { Stack } from "@mui/material";
import { queries } from "../../../constants/talent-profile";

export default function QueriesList() {
  return (
    <ViewMoreList title="Queries" onViewMore={() => {}} maxHeight="600px">
      <Stack direction="column" gap={2}>
        {queries.map((query, index) => (
          <QueriesCard
            key={index}
            username={query.username}
            email={query.email}
            content={query.content}
            timestamp={query.timestamp}
            likes={query.likes}
            replies={query.replies}
            onLike={() => {}}
            onReply={() => {}}
            onMore={() => {}}
          />
        ))}
      </Stack>
    </ViewMoreList>
  );
}
